import EditFormPage from "@Alternatives/Forms/Pages/EditFormPage.vue";
import FormsPage from "@Alternatives/Forms/Pages/FormsPage.vue";

export const routes = [
    {
        path: "/pp/forms/:workspaceId/:projectId",
        component: FormsPage
    },
    {
        path: "/pp/edit-form/:workspaceId/:projectId/:formId",
        component: EditFormPage
    },
]
